'use client';
import React, { useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Title from '@/src/components/common/ui/text/Title.jsx';
import useDeviceTypeMobile from '@/src/hooks/useDeviceTypeMobile.jsx';
import Button from '@/src/components/common/ui/buttons/Button.jsx';
import getBlogDataJson from '@/public/json/blog/blog_list.json';
import BlogSingle from '@/src/components/common/ui/single-item/BlogSingle.jsx';
import { StyledBlogList } from '@/src/components/common/eco/sections/blog-list/blog-list.style.js';
import BlogSingleMobile from '@/src/components/common/ui/single-item/BlogSingleMobile.jsx';
import Link from 'next/link';

const BlogList = ({ data, limit,id, allBlog }) => {
	const isMobile = useDeviceTypeMobile();

	const [getBlogData, setBlogData] = useState(() => allBlog );



	// Memoize the renderBrandItem function to prevent unnecessary re-renders
	const renderBrandItem = useMemo(() =>
			(e, index) => {
				let thumb = null;

				if(e?.images){
					 thumb = e?.images?.find((f) => f?.thumb === 'on');

				}
				const dateString = e?.data?.date; // Example: "2025-02-12"

				const formatDate = (dateString) => {
					const months = [
						"January", "February", "March", "April", "May", "June",
						"July", "August", "September", "October", "November", "December"
					];

					if (!dateString) return { day: "", month: "", year: "" };

					// Parse date parts explicitly to avoid timezone issues
					const [year, month, day] = dateString.split('-').map(Number);

					// Use Date.UTC to get consistent date in UTC
					const dateObj = new Date(Date.UTC(year, month - 1, day));

					return {
						day: dateObj.getUTCDate(),
						month: months[dateObj.getUTCMonth()],
						year: dateObj.getUTCFullYear()
					};
				};

				const { day, month, year } = formatDate(dateString);

				return (
					<Col md={4} key={index} className={'blog-single-item-open fade-up'}>

						<BlogSingle text={e?.data?.subtitle} title={e?.data?.title} link={`/events/${e?.data?.slug}`} img={thumb?.full_path ? thumb?.full_path : ''} day={day} month={month} year={year} />

					</Col>
				);
			},
		[],
	);
	const renderBrandItemMobile = useMemo(() =>
			(e, index) => {
				let thumb = null;

				if(e?.images){
					 thumb = e?.images?.find((f) => f?.thumb === 'on');

				}
				const dateString = e?.data?.date; // Example: "2025-02-12"

				const formatDate = (dateString) => {
					const months = [
						"January", "February", "March", "April", "May", "June",
						"July", "August", "September", "October", "November", "December"
					];

					if (!dateString) return { day: "", month: "", year: "" };

					// Parse date parts explicitly to avoid timezone issues
					const [year, month, day] = dateString.split('-').map(Number);

					// Use Date.UTC to get consistent date in UTC
					const dateObj = new Date(Date.UTC(year, month - 1, day));

					return {
						day: dateObj.getUTCDate(),
						month: months[dateObj.getUTCMonth()],
						year: dateObj.getUTCFullYear()
					};
				};

				const { day, month, year } = formatDate(dateString);

				return (
					<Col md={4} key={index} className={'blog-single-item-open fade-up'}>
						<BlogSingleMobile text={e?.data?.subtitle} title={e?.data?.title} link={`/events/${e?.data?.slug}`} img={thumb?.full_path ? thumb?.full_path : ''} day={day} month={month} year={year} />
					</Col>
				);
			},
		[],
	);



	return (
		<StyledBlogList id={id} className={`brandlist forPage`} >
			<Container>
				<Row>



					{
						getBlogData && getBlogData?.length > 0 && limit && !isMobile &&
						getBlogData.map((e, index) => renderBrandItem(e, index))
					}
					{
						getBlogData && getBlogData?.length > 0 && limit && isMobile &&
						getBlogData.map((e, index) => renderBrandItemMobile(e, index))
					}


				</Row>
			</Container>
		</StyledBlogList>
	);
};





export default BlogList;